import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Navigation,
  ProfileIntro,
  About,
  Expertise,
  // Services, // Temporarily commented out – re-enable by removing this comment
  Personal,
  Writing,
  Books,
  Contact,
  ScrollToTop,
  Footer
} from './components';
import { useScrollNavigation } from './hooks/useScrollNavigation';
import { useLegacyHashScroll } from './hooks/useLegacyHashScroll';
import { profileData } from './data/profileData';
import { initGA, logPageView } from './utils/analytics';
import './App.css';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID ?? '';

// One page serves both "/" and "/writing/:slug"; the Writing section reads the slug itself,
// so opening an article never remounts the page.
const App: React.FC = () => {
  const sections = useMemo(() => profileData.navigation.map(nav => nav.id), []);
  const { activeSection, scrollToSection } = useScrollNavigation(sections);
  const { pathname } = useLocation();

  useLegacyHashScroll();

  useEffect(() => {
    initGA(GA_MEASUREMENT_ID);
  }, []);

  useEffect(() => {
    logPageView();
  }, [pathname]);

  return (
    <div className="App loaded">
      {/* Skip to content link for accessibility */}
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Navigation activeSection={activeSection} scrollToSection={scrollToSection} />
      <main id="main-content" tabIndex={-1}>
        <ProfileIntro scrollToSection={scrollToSection} />
        <About />
        <Writing publications={profileData.publications} />
        <Expertise />
        {/* <Services />  // Re-enable Services section by uncommenting this line */}
        <Books books={profileData.books} />
        <Personal />
        <Contact />
      </main>
      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default App;
